<template>
  <div class="bg-gray-900 flex h-screen items-center justify-center">
    <UCard class="w-md">

      <div class="logo-section text-center py-2">
        <img src="/img/settler-exchange-logo A light bg.png" class="w-[80%] max-w-[250px] m-auto">
      </div>

      <h1 class="text-center p-4 text-2xl">Register Account</h1>

      <UAlert
v-show="errorMessage" class="mb-4" variant="subtle" color="error" title="Error registering account"
        :description="errorMessage" />
      <UAlert
v-show="successMessage" class="mb-4" variant="subtle" color="success" title="Success"
        :description="successMessage" />

      <UForm :schema="schema" :state="formData" class="space-y-4" @submit="register">

        <UFormField label="Name" name="name">
          <UInput v-model="formData.name" icon="i-lucide-user" size="xl" class="w-full" autofocus />
        </UFormField>

        <UFormField label="Email" name="email">
          <UInput v-model="formData.email" icon="i-lucide-at-sign" size="xl" class="w-full" />
        </UFormField>

        <UFormField label="Password" name="password">
          <UInput
v-model="formData.password" icon="i-lucide-lock" class="w-full" size="xl" placeholder="Password"
            :type="showPassword ? 'text' : 'password'" :ui="{ trailing: 'pe-1' }">
            <template #trailing>
              <UButton
color="neutral" variant="link" size="sm"
                :icon="showPassword ? 'i-lucide-eye-off' : 'i-lucide-eye'"
                :aria-label="showPassword ? 'Hide password' : 'Show password'" :aria-pressed="showPassword"
                aria-controls="password" @click="showPassword = !showPassword" />
            </template>
          </UInput>
        </UFormField>

        <UButton type="submit" class="w-full justify-center mt-2" size="xl">Register</UButton>

        <p class="text-center">Already have an account? <UButton variant="link" to="/login">Log in</UButton>
        </p>

      </UForm>

    </UCard>
  </div>
</template>

<script lang="ts" setup>
import * as z from 'zod'
import type { FormSubmitEvent } from '@nuxt/ui'

const showPassword = ref(false);
const errorMessage = ref('');
const successMessage = ref('');
const supabase = useSupabaseClient();

const schema = z.object({
  name: z.string(),
  email: z.string().email('Invalid email'),
  password: z.string().min(8, 'Must be at least 8 characters')
})

type Schema = z.output<typeof schema>

const formData = ref<Partial<Schema>>({
  name: undefined,
  email: undefined,
  password: undefined
})

async function register(event: FormSubmitEvent<Schema>) {

  console.log(event.data)

  try {

    successMessage.value = '';
    errorMessage.value = '';

    const { error } = await supabase.auth.signUp({
      email: event.data.email,
      password: event.data.password,
      options: {
        data: {
          name: event.data.name,
        }
      }
    });
    if (error) throw error;

    successMessage.value = "User successfully registered. Check your email.";

  } catch (error) {
    errorMessage.value = (error instanceof Error) ? error.message : String(error);
  }
}

</script>

<style></style>